import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { BaseChip } from "./BaseChip";
export const Chip = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color = "neutral",
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(BaseChip, _extends({}, rest, {
    color: color,
    ref: ref
  }));
});
Chip.displayName = "Chip";
//# sourceMappingURL=Chip.js.map